import Box from '@mui/material/Box';
import {
  SectionTitle,
  Subsection,
  SubsubsectionTitle,
  BodyText,
} from '../components/SectionPrimitives';

export function Section2(): JSX.Element {
  return (
    <Box>
      <SectionTitle>2. Data Protection and Confidentiality</SectionTitle>

      <Subsection title="2.1 Independent Controllers">
        Each party shall comply with its obligations under the UK General Data
        Protection Regulation (UK GDPR) and the Data Protection Act 2018. The
        parties acknowledge that each acts as an independent data controller in
        respect of any personal data it processes. Neither party shall be
        responsible for the data processing activities of the other.
      </Subsection>

      <Subsection title="2.2 Data Collected by UKVG">
        In connection with the Agreement, UKVG will process the following
        categories of personal data relating to the Partner's nominated
        contacts: name, business email address, business address, and telephone
        number. This data is processed for the purpose of administering the
        partnership, delivering the agreed services, and maintaining financial
        records. The lawful basis for this processing is the performance of a
        contract (Article 6(1)(b), UK GDPR) and, where applicable, compliance
        with a legal obligation (Article 6(1)(c), UK GDPR).
      </Subsection>

      <Subsection title="2.3 Payment Data">
        Payment transactions are processed by bank transfer. UKVG does not store
        full payment credentials. Bank details provided to the Partner at the
        point of payment are used solely for the purpose of receiving the agreed
        fee and are not shared with any third party.
      </Subsection>

      <Subsection title="2.4 Data Retention">
        UKVG will retain personal data only for as long as necessary for the
        purposes for which it was collected. Financial and contractual records
        will be retained for a minimum of six years following the end of the
        agreement in accordance with HMRC requirements. All other personal data
        will be deleted or anonymised within 90 days of the agreement ending,
        unless the Partner has entered into a new agreement with UKVG.
      </Subsection>

      <Subsection title="2.5 End of Agreement">
        <SubsubsectionTitle>Vineyard Listing Agreements</SubsubsectionTitle>
        <BodyText>
          Upon cancellation or non-renewal, the Partner's listing will revert to
          a free Basic Listing level within 30 days of the agreement end date,
          reflecting the platform's commitment to featuring all UK vineyards.
          Where a Partner downgrades to a lower subscription tier, the Vendor
          will adjust the listing accordingly within 14 days of the new
          agreement commencing.
        </BodyText>
        <SubsubsectionTitle>
          Commercial Partnership Agreements
        </SubsubsectionTitle>
        <BodyText>
          Upon cancellation or non-renewal, UKVG will remove the Partner's
          information and brand assets from the platform within 30 days of the
          agreement end date.
        </BodyText>
        <BodyText>
          In both cases, the Partner may request written confirmation that their
          personal data has been deleted or anonymised upon full cancellation;
          UKVG will respond within 40 days of the request.
        </BodyText>
      </Subsection>

      <Subsection title="2.6 Partner Responsibilities">
        The Partner warrants that any content, images, or materials supplied to
        UKVG for publication on the platform have been obtained and may be
        shared in compliance with applicable data protection legislation,
        including where such content features identifiable individuals. UKVG
        accepts no liability for any data protection breach arising from content
        supplied by the Partner.
      </Subsection>

      <Subsection title="2.7 Data Breaches">
        In the event that either party becomes aware of a personal data breach
        affecting personal data processed under the Agreement, it shall notify
        the other party without undue delay and no later than 72 hours of
        becoming aware. Each party shall remain independently responsible for
        notifying the Information Commissioner's Office (ICO) in accordance with
        its obligations under UK GDPR where required.
      </Subsection>

      <Subsection title="2.8 Confidentiality">
        UKVG agrees to keep the personal and business information of the Partner
        confidential, save for information the Partner has agreed to make
        publicly available on the Platform. Information shall not be disclosed
        to any third party without the prior written consent of the Partner.
      </Subsection>

      <Subsection title="2.9 Privacy Policy">
        Full details of how UKVG collects, uses, and protects personal data are
        set out in the UK Vineyard Guide Privacy Policy, available upon request.
        Partners are encouraged to review this policy prior to entering into an
        Agreement.
      </Subsection>
    </Box>
  );
}
